// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__nJtN6","colCheckbox":"styles_colCheckbox__3tbzv"};